import React from 'react';
import styles from './MapModal.module.css';

interface MapModalProps {
  onClose: () => void;
  children: React.ReactNode;
}

export const MapModal: React.FC<MapModalProps> = ({ onClose, children }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.contentWrapper}>
        <button className={styles.closeButton} onClick={onClose}>
          <img src="/static/images/map/close_white.svg" alt="Close" className={styles.closeIcon} />
        </button>
        <div className={styles.modal}>{children}</div>
      </div>
    </div>
  );
};
